import { CurrentUserAction } from '@nal/components/CurrentUser/store/actions';

const initState = null;

export default function currentUserAction(state = initState, action: any) {
    switch (action.type) {
        case CurrentUserAction.GET_ME:
            return state;
        case CurrentUserAction.GET_ME_SUCCESS:
            return action.me;
        default:
            return state;
    }
}
